import { Box, Inline, Text } from '@machobear/design-system'
import { useFormikContext, FormikProps } from 'formik'
import { useTranslation } from 'react-i18next'
import sanitizeHtml from 'sanitize-html'
import { ReadCheckmark } from '@/components/icons'
import formatDate from '@/utils/format-date'
import { replaceVariablesWithValues } from '../helpers/utils'
import { VariablesData } from '../helpers/types'
import { PreviewBoxStyle } from '../index.css'

export type VariablesRawData = Record<string, VariablesData>

type PreviewMessageValues = {
  auto_reply_title: string
  auto_reply_message: string
  variables: string
  set_active: boolean
  new_created_listing: boolean
}

const PreviewMessage = ({ data }: VariablesRawData) => {
  const { t } = useTranslation()

  const {
    values
  }: {
    values: FormikProps<PreviewMessageValues>['values']
  } = useFormikContext()
  const personalizedMessage: string[] = values.auto_reply_message
    ? replaceVariablesWithValues(values.auto_reply_message, data)
    : []

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap="small"
      justifyContent="spaceBetween"
      padding="medium"
      alignItems="flexStart"
      borderRadius="standard"
      border="borderNeutralLight"
      background="neutralLight"
      width="full"
      height="full"
    >
      <Box display="flex" flexDirection="column" width="full">
        <Text size="small" weight="regular">
          {t('l.settings.view.auto_reply.message_preview', 'Message Preview')}
        </Text>
        <Box
          className={PreviewBoxStyle}
          borderRadius="xlarge"
          padding={'medium'}
          background="info"
          width="full"
          height="full"
          marginTop="small"
        >
          {personalizedMessage.map((txt: string, index: number) => {
            if (txt === '') {
              return <br key={`${txt}-${index}`} />
            } else {
              return (
                <Box
                  dangerouslySetInnerHTML={{ __html: sanitizeHtml(txt) }}
                  style={{ color: 'white' }}
                  key={`${txt}-${index}`}
                />
              )
            }
          })}
        </Box>
      </Box>
      {personalizedMessage.length > 0 && (
        <Box
          display="flex"
          alignItems="center"
          gap="xxxsmall"
          justifyContent="flexEnd"
          width="full"
        >
          <Inline space="xxxsmall">
            <Text size="small" tone="tertiary">
              {t('b.chat.view.today.text', 'Today')}
            </Text>
            <Text size="small" tone="tertiary">
              {formatDate(new Date(), 'hh:mm a')}
            </Text>
          </Inline>
          <ReadCheckmark />
        </Box>
      )}
    </Box>
  )
}

export default PreviewMessage
